import { render, staticRenderFns } from "./PaxSelectorBlock.vue?vue&type=template&id=28d2bfaa&scoped=true&"
import script from "./PaxSelectorBlock.vue?vue&type=script&lang=js&"
export * from "./PaxSelectorBlock.vue?vue&type=script&lang=js&"
import style0 from "./PaxSelectorBlock.vue?vue&type=style&index=0&id=28d2bfaa&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2bfaa",
  null
  
)

export default component.exports